export const heroContent = {
  eyebrow: 'Aides, impots, rappels, extension',
  headline: 'Votre copilote administratif.',
  subtitle:
    "Un chat simple pour trouver vos aides, preparer vos impots et piloter les demarches en arriere-plan.",
  primaryCta: 'Tester mon score',
  secondaryCta: 'Ouvrir le copilote',
  businessCta: 'Voir Skipya Business',
};

export const heroStats = [
  { value: '2', label: 'parcours gratuits avant inscription', color: 'text-[#81d8d0]' },
  { value: '4', label: 'questions pour préparer ses impôts', color: 'text-[#FF6B6B]' },
  { value: '1', label: 'copilote pour piloter les démarches', color: 'text-[#81d8d0]' },
];

export const needOptions = [
  {
    title: 'Trouver mes aides',
    description: "Un court questionnaire estime les aides possibles, les justificatifs et les prochaines demarches.",
    action: 'Estimer mes aides',
    target: 'aid-quiz',
    preSignup: true,
  },
  {
    title: 'Declarer mes impots',
    description: "Anticipez les cases, documents, optimisations et points de vigilance avant impots.gouv.",
    action: 'Preparer mes impots',
    target: 'tax-quiz',
    preSignup: true,
  },
];

export const businessContent = {
  title: 'Skipya Business',
  promise:
    'Aidez vos salaries, etudiants, freelances ou clients a gerer leurs demarches administratives et fiscales, sans multiplier les relances manuelles.',
  targets: [
    'Ecoles',
    'Entreprises',
    'Plateformes freelances',
    'Cabinets comptables',
    'Associations',
    'Mutuelles',
    'Banques',
    'Residences etudiantes',
  ],
};
